/**
 * @desc 根据主体编号获取组织信息
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.warehouseFacadeImpl.getOrganizeList.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/warehouse/getOrganizeList`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
